import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { RATINGS } from '../../../lib/schema.js';
import RadioOptionsField from '../../RadioOptionsField.jsx';

const options = RATINGS.HIGH_MEDIUM_LOW.map((rating) => ({
  label: capitalize(rating),
  value: rating,
}));

function RatingField({ label, name }) {
  return (
    <RadioOptionsField
      id={`stakeholderForm${capitalize(name)}`}
      label={label}
      name={name}
      options={options}
    />
  );
}

RatingField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default RatingField;
